import { render } from "./DetailBooking.vue?vue&type=template&id=26688382"
import script from "./DetailBooking.vue?vue&type=script&lang=js"
export * from "./DetailBooking.vue?vue&type=script&lang=js"

import "./DetailBooking.vue?vue&type=style&index=0&id=26688382&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__